import { set } from "lodash";

export class WorkList extends HTMLElement {
    options = {
        network: {},
        doReferral: false,
        dogTimer: false,
        makeRun: false,
    };

    constructor() {
        super();
    }
    /*
     * Vetology.OneClickReferral._init
     *
     * @description	Initializes the Vetology Platform
     *
     * @return NULL
     *
     */

    connectedCallback() {
        this.init();
    }

    init() {
        $(".popover").remove();
        this.loadEventHandlers();
        this.initDateRangePickerModifications();
        this.checkForSubclinic();
        setTimeout(() => {
            const badge = document.querySelector("#unread-ai-report-case-count-badge");
            if (badge) {
                this.updateMenuBadgeAndCases();
            }
        }, 100);  
    }

    initDateRangePopover() {
        $(".popover").remove();
        const dateRangeBtn = document.querySelector("button.date-range-button");
        if (dateRangeBtn) {
            $(dateRangeBtn).popover({
                animation: true,
                container: "body",
                html: true,
                toggle: "popover",
                placement: "bottom",
                title: "Date range may need to be adjusted",
            });
            $(dateRangeBtn).on("shown.bs.popover", function (event) {
                setTimeout(() => {
                    $(dateRangeBtn).popover("destroy");
                }, 8000);
                dateRangeBtn.addEventListener("click", (event) => {
                    $(dateRangeBtn).popover("destroy");
                });
                $("body").on("click", function (event) {
                    const dateRangeBtn = document.querySelector("button.date-range-button");
                    if (dateRangeBtn) {
                        $(dateRangeBtn).popover("destroy");
                        const popovers = document.querySelectorAll(".popover");
                        popovers.forEach((popover) => {
                            $(popover).hide();
                        });
                    }
                });
            });
        }
    }

    initDateRangePickerModifications() {
        // check for the insertion of the date range picker
        const mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0) {
                    const addedNode = mutation.addedNodes[0];
                    if (typeof addedNode.classList !== "undefined" && addedNode.classList.contains("daterangepicker")) {
                        const drFooter = document.querySelector(".daterangepicker .drp-buttons");
                        const instructionDiv = document.createElement("div");
                        instructionDiv.setAttribute("class", "daterange-instructions");
                        instructionDiv.textContent = "Use either or both calendars to select a begin and end date";
                        drFooter.insertBefore(instructionDiv, drFooter.firstChild);
                    }
                }
            });
        });

        mutationObserver.observe(document.body, {
            childList: true,
            subtree: false,
        });
    }

    loadEventHandlers() {
        if ("ontouchstart" in document.documentElement) {
            $("body").on("ontouchstart", ".action-btns-btns-wrap a", (event) => {
                var el = $(event.target);
                if (el.hasClass("ocr_block")) {
                    this.showNetwork(el);
                } else {
                    this.hideNetwork(el);
                }
            });
        }
        $("body").on("click", ".newCaseNoImages", (e) => {
            this.renderNewCaseNoImages();
        });
        $("body").on("click", ".action-btns-btns-wrap a", (event) => {
            var el = $(event.target);
            if (el.hasClass("ocr_block")) {
                this.showNetwork(el);
            }
        });
        $("body").on("mouseleave", ".box-case", (event) => {
            var el = $(event.target).closest(".case-card").find(".ocr_block");
            this.hideNetwork(el);
        });
        $("body").on("mouseenter", ".action-btns-btns-wrap a", (event) => {
            var el = $(event.target);
            if (el.hasClass("ocr_block")) {
                this.showNetwork(el);
            }
        });
        $("body").on("click", ".setCasesFilter", (event) => {
            var cases = $(event.target).data("cases");
            $('.isFilter[data-filter="CaseID"]').val(cases);
            // remove filter for first/last names
            var $firstName = $(".pageFilters").find("input[data-filter='first_name']");
            var $lastName = $(".pageFilters").find("input[data-filter='last_name']");
            $firstName.val("");
            $lastName.val("");
            $(".isFilter").trigger("change");
        });
        $("body").on("click", ".action-btns .navigate", (event) => {
            event.preventDefault();
            var clickedBtn = $(event.currentTarget);
            var actionBtnsWrap = clickedBtn.closest(".action-btns").find(".action-btns-btns-wrap");
            var clickedBtnOffset = parseFloat(actionBtnsWrap.data("offset"));
            var actionBtnsWrapParent = clickedBtn.closest(".action-btns").find(".action-btns-btns-wrapp");
            var scrollSize = parseFloat(actionBtnsWrap.data("scrollsize"));
            var scrollType = clickedBtn.hasClass("nav-right") ? "-=" : "+=";
            var parentPosition = parseFloat(actionBtnsWrapParent.css("margin-left").replace("-", "").replace("px", ""));
            var wrapPosition = parseFloat(actionBtnsWrap.css("left"));
            var minleft = parseFloat(actionBtnsWrap.data("minleft"));
            var maxleft = parseFloat(actionBtnsWrap.data("maxleft"));

            if (scrollType == "-=" && (wrapPosition <= 0 || wrapPosition - scrollSize <= 0)) {
                scrollType = "";
                scrollSize = 0;
            }
            if (scrollType == "+=" && wrapPosition + scrollSize >= minleft) {
                scrollType = "";
                scrollSize = minleft;
            }
            actionBtnsWrap.animate(
                {
                    left: scrollType + scrollSize,
                },
                100
            );
        });
        $("body").on("click", ".ocrblock_toggler", (event) => {
            event.preventDefault();
            this.hideOcrBlockContent($(event.target).closest(".ocr_block_content"));
        });
        $("body").on("click", ".noCaseFound", (event) => {
            $("body").Vetology(
                "doRequest",
                "POST",
                {
                    id: $(event.target).data("patient"),
                    patientName: $(event.target).data("name"),
                    patientLastName: $(event.target).data("lastname"),
                    clinicid: $(event.target).data("clinicid"),
                },
                "/create-case-no-images",
                function (json) {
                    $('[data-filter="case_id"]').val(json.case);
                    $('[data-filter="FirstName"]').val("");
                    $('[data-filter="LastName"]').val("");
                    $('[data-filter="ClinicID"]').val("");
                    $('[data-filter="ClinicName"]').val("");
                    $('[data-filter="IsStat"]').val("");
                    $('[data-filter="Modality"]').val("");
                    setTimeout(function () {
                        $("body").Vetology(
                            "vetologyShowDialog",
                            "Success:",
                            "A new case with ID " +
                                json.case +
                                " has been created and is listed, when you are ready to submit it for review click on the submit button.",
                            "success"
                        );
                        $(".isFilter").change();
                        $("body").platform("do", [
                            "showDialog",
                            "Success",
                            "A new case with ID " +
                                json.case +
                                " has been created and is listed, when you are ready to submit it for review click on the submit button.",
                        ]);
                    }, 1000);
                },
                "JSON"
            );
        });
        $("body").on("click", ".createPetRecord", (event) => {
            var id = parseInt($(event.target).data("id"));
            $("body").Vetology(
                "doRequest",
                "POST",
                {
                    id: id,
                },
                "/get-patient-cases",
                function (json) {
                    $(".targetHtml").html(json.data);
                    $(".pagerTarget").html(json.pager);
                    $(".pagerTarget2").html(json.pager2);
                    $(".targetHtml").append(
                        '<button class="btn btn-warning btn-flat noCaseFound" data-patient="' +
                            id +
                            '">My case is not on the list</button>'
                    );
                    if (json.cCount == 0) {
                        setTimeout(function () {
                            $(".noCaseFound").click();
                        });
                    }
                },
                "JSON"
            );
        });
        $("body").on("click", ".comingSoon", (event) => {
            event.preventDefault();
            $("body").platform("do", ["showDialog", "Attention", $(event.target).data("message")]);
        });
        $("body").on("click", ".ocr_message_done button", (event) => {
            event.preventDefault();
            var ocrParent = $(event.target).closest(".ocr_message_done");
            ocrParent.addClass("hide");
        });
        $("body").on("click", ".ocr_message button", (event) => {
            event.preventDefault();
            var ocrParent = $(event.target).closest(".ocr_message");
            if ($(event.target).hasClass("closeRN")) {
                ocrParent.addClass("hide");
                return;
            }
            var message = ocrParent.find("textarea").val();
            doAjax(
                "GET",
                {
                    id: ocrParent.data("id"),
                    message: message,
                },
                "/leave_ocr_message",
                function (json) {
                    if (json.valid) {
                        ocrParent.closest(".box-case").find(".ocr_message").addClass("hide");
                        ocrParent.closest(".box-case").find(".ocr_message_done").removeClass("hide");
                    } else {
                        ocrParent.find(".ocr_emessage").html(json.reson);
                    }
                },
                "JSON"
            );
        });
        $("body").on("click", ".referralComplete", (event) => {
            event.preventDefault();
            var el = $(event.target);
            this.completeReferral(el);
        });
        $("body").on("click", ".doOCR", (event) => {
            event.preventDefault();
            var clinic = $(event.target);
            this.doOCRTrigger(clinic);
        });
        $("body").on("mouseenter", ".case_mascot", (event) => {
            $(event.target).find("span").addClass("animatron");
        });
        $("body").on("mouseleave", ".case_mascot", (event) => {
            $(event.target).find("span").removeClass("animatron");
        });
        setInterval((event) => {
            this.animateDogs();
        }, 100);
        setInterval((event) => {
            this.animateCats();
        }, 350);
        // $("body").on("click", ".newCaseNotFound", (event) => {
        //     var el = $(event.target);
        //     var patient = el.data("patient");
        //     this.createCaseFromData(patient.ClinicPatientID, patient);
        // });
        $("body").on("click", ".caseRestore", (event) => {
            var el = $(event.target);
            this.restoreCase(el);
        });

        this.loadEventHandlersFinish();
    }

    loadEventHandlersFinish() {
        $("body").on("click", ".vetology-view[href*='/prelim/'], .vetology-circle-down[href*='/prelim/']", (event) => {
            event.preventDefault();
            var $el = $(event.target);
            var url = $el[0].href;
            var $dlg = $("body").Vetology("instance").options.modal;
            // show confirmation of prelim report
            $("body").Vetology(
                "vetologyShowDialog",
                "Preliminary Report",
                "You are about to view a PRELIMINARY CONSULTANT REPORT. " +
                    "The FINAL REPORT is still PENDING.  " +
                    "Click OK to acknowledge and view this PRELIMINARY REPORT.",
                "info",
                function (data, modal) {
                    $dlg.modal("hide");
                    if (url.includes("/v/")) {
                        var win = window.open(url, "_blank");
                    } else {
                        window.open(url);
                    }
                }
            );
            $dlg.find(".modal-footer [data-dismiss]").hide();
        });
        $("body").on("click", "#clear-all-filters", (event) => {
            $("input.isFilter", ".pageFilters .filter-column").val("");
            $("select.isFilter", ".pageFilters").find("option:selected").prop("selected", false);
            $(".isFilter[data-filter='ScheduledDate']").val("");
            const dateRangeButton = this.querySelector(".date-range-button");
            const startDate = new Date();
            startDate.setDate(startDate.getDate() - 60);
            const endDate = new Date();
            const dateRange = startDate.toISOString().split("T")[0] + "::" + endDate.toISOString().split("T")[0];
            const scheduledDate = document.querySelector('.isFilter[data-filter="ScheduledDate"]');
            scheduledDate.value = dateRange;
            const btnText = dateRangeButton.querySelector("button.date-range-button span.calendar-span-text");
            btnText.textContent = "Last 60 Days";
            const dateRangePicker = document.querySelector("date-range-picker");
            dateRangePicker.clearFilters();
            setTimeout(function () {
                $(".isFilter").trigger("change");
            }, 500);
        });

        document.addEventListener("filter-change", (event) => {
            if (
                event.detail.originalEvent.target.classList.contains("isFilter") &&
                event.detail.filter === "ClinicID"
            ) {
                this.clearSubClinics();
            }
        });
        const contentWrapper = document.querySelector(".content-wrapper");
        const clientTypeSwitchButtons = contentWrapper.querySelectorAll(".client-type-switch input");
        contentWrapper.addEventListener("click", (event) => {
            let target = event.target;
            if (target.tagname !== "A" && target.classList.contains('client-type-switch') === false) {
                let possibleTarget = target.closest("a");
                if (!possibleTarget) {
                    possibleTarget = target.closest("button");
                };
                if (possibleTarget) {
                    target = possibleTarget;
                } else {
                    return;
                }
            }
            if (target.classList.contains("client-type-switch")) {
                this.switchSubmissionClientType(event);
            }
            if (target.classList.contains("cancel-submit")) {
                this.cancelCaseSubmission(event);
            }
            if (target.classList.contains("submit-cancellation")) {
                this.submitReadCancellation(event);
            }
            // check for refresh worklist button
            if (target.id === "refresh-worklist") {
                setTimeout(function () {
                    $(".isFilter").trigger("change");
                }, 500);
            }
        });

        // watch for the removal of filteringRecords from the body class
        const bodyObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === "class") {
                    const body = $(mutation.target);
                    const prevClassList = mutation.oldValue.split(" ");
                    if (prevClassList.includes("filteringRecords") && !body.hasClass("filteringRecords")) {
                        this.initDateRangePopover();
                        this.checkForNoCasesFound();
                        this.updateSubClinics();
                        this.updateMenuBadgeAndCases();
                        const worklistLoadedEvent = new CustomEvent("work-list-loaded", {
                            bubbles: true,
                            cancelable: true,
                        });
                        document.dispatchEvent(worklistLoadedEvent);
                    }
                }
            });
        });

        bodyObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"],
            attributeOldValue: true,
        });

        $(window).resize((event) => {
            this.onWindowResize();
            const sidebarToggler = document.querySelector(".sidebar-toggler");
            if (sidebarToggler && window.innerWidth < 768 && !sidebarToggler.classList.contains("sidebar-collapsed")) {
                sidebarToggler.click();
            }
        });

        document.addEventListener("aiReportContainerClosed", this.updateMenuBadgeAndCases.bind(this));

        window.addEventListener("load", this.createWorklistMenuBadge.bind(this));
        this.onWindowResize();
        this.checkIfCaseSubmitted();
    }

    onDateRangeChange(event) {
        const dateRangeSelector = event.target;
        const dateRangeText = dateRangeSelector.value;
        if (dateRangeText == "custom") {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            $("date-range-picker-modal").modal("show");
        }
    }

    checkForNoCasesFound() {
        const dateRangeButton = document.querySelector("button.date-range-button");
        const dateRangTextSpan = dateRangeButton.querySelector("span.calendar-span-text");
        const caseContainer = document.querySelector(".mainContent .targetHtml");
        const noCasesFound = caseContainer.querySelectorAll("div[data-case]").length === 0;
        if (noCasesFound && dateRangTextSpan && !dateRangTextSpan.textContent.includes("All time")) {
            $(dateRangeButton).popover("show");
        }
    }

    restoreCase(el) {
        el.html("Restoring case, please wait...");
        var dateSelector = new Date();
        var id = el.data("case");
        $("body").Vetology(
            "doRequest",
            "GET",
            { CaseID: id },
            "/worklist/case-restore",
            function (json) {
                if (json.restored) {
                    el.html("Case restored, please wait, re-rendering");
                    el.closest(".caseDeleted").removeClass("caseDeleted");
                    el.remove();
                    $("body").Vetology(
                        "vetologyShowDialog",
                        "Case Restore:",
                        "Your case " + id + " has been restored",
                        "success"
                    );
                } else {
                    el.html("Could not restore, please try again.");
                }
            },
            "JSON"
        );
    }

    replacePageArrows() {
        const prevPage = document.querySelector('.pager-target-bottom page-item[ariaLabel*="Previous"]');
        const nextPage = document.querySelector('.pager-target-bottom page-item[ariaLabel*="Next"]');
        if (prevPage) {
            const prevSvg = document.createElement("material-design-svg");
            prevSvg.setAttribute("data-icon", "filled__play_arrow");

            prevPage.appendChild(prevSvg);
        }
    }

    completeReferral(el) {
        var o = this;
        var currentForm = $("form.case_" + el.data("case"));
        var ocrBlockContent = currentForm.find(".ocr_block_content");
        ocrBlockContent.removeClass("doNotHide");
        var data = currentForm.serialize();
        $("body").Vetology(
            "doRequest",
            "GET",
            data,
            "/update_refer",
            function (json) {
                if (json.valid) {
                    var message = currentForm.find('[name="referralnote"]').val();
                    var caseId = currentForm.find('[name="case"]').val();
                    var hospital = currentForm.find('[name="referto"]').val();
                    data = {
                        case: caseId,
                        sh: hospital,
                        message: message,
                    };
                    setTimeout(function () {
                        $("body").Vetology(
                            "doRequest",
                            "GET",
                            data,
                            "/ocr",
                            function (json) {
                                if (json.error == true) {
                                    $(".referral_" + caseId)
                                        .modal("hide")
                                        .remove();
                                    $("body").append(json.form);
                                    $(".referral_" + caseId).modal();
                                } else {
                                    o.completeReferralProcess(caseId, data, json);
                                }
                            },
                            "JSON",
                            false,
                            "Please wait while we prepare the referral",
                            "We are almost done..."
                        );
                    }, 1000);
                } else {
                    $.each(json.missing, function (i, e) {
                        currentForm
                            .find('[name="' + e + '"]')
                            .closest(".form-group")
                            .addClass("has-error");
                    });
                }
            },
            "JSON",
            false,
            "Please wait while we prepare the referral",
            "We are almost done..."
        );
    }

    hideOcrBlockContent(obc) {
        // we want to show a fade out transition on element
        obc.removeClass("doNotHide").fadeOut(300, function () {
            obc.addClass("hide");
        });
    }

    showOcrBlockContent(obc) {
        // we want to show a fade in transition on element
        obc.removeClass("hide").fadeIn(300, function () {
            obc.removeClass("doNotHide");
        });
    }
    makeRun(animation, isCat) {
        var o = this;
        var direction = o.options.doReferral ? "r" : "";
        const curClass = "vetology-" + (isCat ? "cat" : "dog") + "-" + direction;
        switch (true) {
            case animation.hasClass(curClass + "1"):
                animation.removeClass(curClass + "1");
                animation.addClass(curClass + "2");
                break;
            case animation.hasClass(curClass + "2"):
                animation.removeClass(curClass + "2");
                animation.addClass(curClass + "3");
                break;
            case animation.hasClass(curClass + "3"):
                animation.removeClass(curClass + "3");
                animation.addClass(curClass + "4");
                break;
            case animation.hasClass(curClass + "4"):
                animation.removeClass(curClass + "4");
                animation.addClass(curClass + "5");
                break;
            case animation.hasClass(curClass + "5"):
                animation.removeClass(curClass + "5");
                animation.addClass(curClass + "6");
                break;
            case animation.hasClass(curClass + "6"):
                animation.removeClass(curClass + "6");
                animation.addClass(curClass + "7");
                break;
            case animation.hasClass(curClass + "7"):
                animation.removeClass(curClass + "7");
                animation.addClass(curClass + "1");
                break;
        }
        animation.animate(
            {
                left: (o.options.doReferral ? "+" : "-") + "=25px",
            },
            100
        );
    }

    doOCRTrigger(clinic) {
        var o = this;
        if (clinic.hasClass("in-process")) {
            return;
        }
        clinic.closest(".ocr_block_content").addClass("doNotHide");
        if (clinic.hasClass("firstAccept")) {
            $("body").platform("do", ["showDialog", "Attention", "<p>Please wait, there is a pending request.</p>"]);
            var id = clinic.data("rid");
            $("body").platform("do", ["loading", true]);
            $.ajax({
                url: "/acceptRequest",
                data: {
                    id: id,
                },
                success: function (data) {
                    $("body").platform("do", ["loading", false]);
                    if (data.success) {
                        clinic.removeClass("firstAccept").removeClass("bg-navy").addClass("bg-olive");
                        $("body").platform("do", [
                            "showDialog",
                            "Success",
                            "<p>The request has been successfully accepted.</p><p>Initiating referral</p>",
                        ]);
                        clinic.click();
                    } else {
                        $("body").platform("do", ["showDialog", "Error", data.message]);
                    }
                },
                dataType: "JSON",
            });
            return;
        }
        if (clinic.hasClass("active-referral")) {
            $("body").Vetology(
                "vetologyShowDialog",
                "Attention:",
                "<p>You have already referred this case to " + clinic.html(),
                "warning"
            );
            clinic.closest(".ocr_block_content").removeClass("doNotHide");
            return;
        }
        clinic.addClass("in-process");
        var ocrParent = clinic.closest(".box-case");
        var animation = ocrParent.find(".dog-animation");
        ocrParent.find(".ocr_message").addClass("hide");
        ocrParent.find(".ocr_message_done").addClass("hide");
        var isCat = ocrParent.hasClass("box-cat");
        animation
            .clearQueue()
            .removeAttr("style")
            .attr("class", isCat ? "dog-animation vetology-cat-r1" : "dog-animation vetology-dog-r1");
        ocrParent.find(".dog-runner").removeClass("hide");
        clinic.data("name", clinic.html());
        ocrParent.find(".ocr_block_content a").addClass("hide");
        clinic.html('Click here to cancel referral <span class="timer">10</span>').removeClass("hide");
        o.options.doReferral = true;
        o.options.makeRun = setInterval(function () {
            o.makeRun(animation, isCat);
        }, 150);
        o.options.dogTimer = setInterval(function () {
            o.animateDogRunner(clinic, ocrParent);
        }, 400);
        clinic.on("click", function (e) {
            e.preventDefault();
            if (!clinic.hasClass("in-process")) {
                return;
            }
            o.options.doReferral = o.options.doReferral ? false : true;
            animation
                .clearQueue()
                .removeAttr("style")
                .attr(
                    "class",
                    isCat
                        ? "dog-animation vetology-cat-" + (o.options.doReferral ? "r" : "") + "1"
                        : "dog-animation vetology-dog-" + (o.options.doReferral ? "r" : "") + "1"
                );
        });
    }

    animateDogRunner(clinic, ocrParent) {
        var o = this;
        var seconds = parseInt(clinic.find(".timer").html(), 10);
        if (o.options.doReferral) {
            seconds--;
            clinic.find(".timer").html(seconds).removeClass("hide");
            if (seconds == 0) {
                clearInterval(o.options.dogTimer);
                ocrParent.find(".dog-runner").animate(
                    {
                        opacity: 0,
                    },
                    100,
                    function () {
                        clearInterval(o.options.makeRun);
                        ocrParent.find(".dog-runner").addClass("hide").removeAttr("style");
                    }
                );
                clinic.html(clinic.data("name"));
                ocrParent.find(".ocr_block_content a").removeClass("hide");
                o.hideOcrBlockContent(ocrParent.find(".ocr_block_content"));
                var ocr_block = ocrParent.find(".ocr_block");
                clinic.removeClass("in-process");
                $("body").Vetology(
                    "doRequest",
                    "GET",
                    {},
                    "/" + clinic.data("url"),
                    function (json) {
                        if (json.error == true) {
                            if (typeof json.form == "undefined") {
                                $("body").platform("do", ["showDialog", "Attention", json.message]);
                            } else {
                                $(".referral_" + ocrParent.find(".case_id").data("id")).remove();
                                $("body").append(json.form);
                                $(".referral_" + ocrParent.find(".case_id").data("id")).modal();
                                clinic.closest(".ocr_block_content").removeClass("doNotHide");
                            }
                        } else {
                            var ocrCount = 1;
                            if (ocr_block.find("span").length > 0) {
                                ocrCount += parseInt(ocr_block.find("span").html(), 10);
                                ocr_block.find("span").remove();
                            }
                            ocr_block.prepend('<span class="badge bg-yellow">' + ocrCount + "</span>");
                            var ocrMessage = ocrParent.find(".ocr_message");
                            ocrMessage.removeClass("hide").data("id", json.id).find(".shname").html(json.hospital);
                            ocrMessage.find(".shphone").html(json.hospitalPhone);
                            var ocrMessage2 = ocrParent.find(".ocr_message_done");
                            ocrMessage2.find(".shphone").html(json.hospitalPhone);
                            ocrMessage2.find(".shname").html(json.hospital);
                            ocrParent
                                .find(".caseDelete")
                                .replaceWith(
                                    '<a href="#" class="btn btn-app btn-flat bg-primary"><i class="vetology-database"></i>Store</a>'
                                );
                            clinic
                                .addClass("active-referral")
                                .append('<span class="badge bg-yellow pull-right">&#x2713;</span>');
                            clinic.closest(".ocr_block_content").removeClass("doNotHide");
                        }
                    },
                    "JSON",
                    false,
                    "Please wait while we prepare the referral",
                    "We are almost done..."
                );
            }
        } else {
            seconds++;
            clinic.find(".timer").html(seconds).addClass("hide");
            ocrParent.find(".ocr_block_content a").removeClass("hide");
            ocrParent.find(".ocr_block_content").addClass("hide");
            if (seconds == 10) {
                clearInterval(o.options.dogTimer);
                ocrParent.find(".dog-runner").animate(
                    {
                        opacity: 0,
                    },
                    1000,
                    function () {
                        clearInterval(o.options.makeRun);
                        ocrParent.find(".dog-runner").addClass("hide").removeAttr("style");
                        clinic.closest(".ocr_block_content").removeClass("doNotHide");
                    }
                );
                clinic.html(clinic.data("name")).removeClass("in-process");
            }
        }
    }

    animateDogs() {
        $(".isDog.animatron").each(function () {
            var dog = $(this);
            switch (true) {
                case dog.hasClass("vetology-dog-s1"):
                    dog.removeClass("vetology-dog-s1").addClass("vetology-dog-s2");
                    break;
                case dog.hasClass("vetology-dog-s2"):
                    dog.removeClass("vetology-dog-s2").addClass("vetology-dog-s3");
                    break;
                case dog.hasClass("vetology-dog-s3"):
                    dog.removeClass("vetology-dog-s3").addClass("vetology-dog-s4");
                    break;
                case dog.hasClass("vetology-dog-s4"):
                    dog.removeClass("vetology-dog-s4").addClass("vetology-dog-s5");
                    break;
                case dog.hasClass("vetology-dog-s5"):
                    dog.removeClass("vetology-dog-s5").addClass("vetology-dog-s6");
                    break;
                case dog.hasClass("vetology-dog-s6"):
                    dog.removeClass("vetology-dog-s6").addClass("vetology-dog-s1");
                    break;
            }
        });
    }

    animateCats() {
        $(".isCat.animatron").each(function () {
            var cat = $(this);
            switch (true) {
                case cat.hasClass("vetology-cat-s1"):
                    cat.removeClass("vetology-cat-s1").addClass("vetology-cat-s2");
                    break;
                case cat.hasClass("vetology-cat-s2"):
                    cat.removeClass("vetology-cat-s2").addClass("vetology-cat-s3");
                    break;
                case cat.hasClass("vetology-cat-s3"):
                    cat.removeClass("vetology-cat-s3").addClass("vetology-cat-s4");
                    break;
                case cat.hasClass("vetology-cat-s4"):
                    cat.removeClass("vetology-cat-s4").addClass("vetology-cat-s5");
                    break;
                case cat.hasClass("vetology-cat-s5"):
                    cat.removeClass("vetology-cat-s5").addClass("vetology-cat-s6");
                    break;
                case cat.hasClass("vetology-cat-s6"):
                    cat.removeClass("vetology-cat-s6").addClass("vetology-cat-s1");
                    break;
            }
        });
    }


    showNetwork(el) {
        var o = this;
        var clinic = el.data("clinic");
        if (typeof o.options.network[clinic] === "undefined") {
            toastr.info("Loading network, please wait...", "Loading Network", { positionClass: "toast-top-center" });

            var url = "/one-click-referral/clinic/network?cid=" + clinic;
            $.ajax({
                url: url,
                success: function (data) {
                    const ocrBlockContent = el.closest(".box-case").find(".ocr_block_content");
                    ocrBlockContent.get(0).style.display = "none";
                    o.options.network[clinic] = data;
                    o.renderNetwork(el, clinic);
                    o.showOcrBlockContent(ocrBlockContent);
                },
                error: function (data) {},
                dataType: "JSON",
            });
        } else {
            o.renderNetwork(el, clinic);
            o.showOcrBlockContent(el.closest(".box-case").find(".ocr_block_content"));
        }
    }

    renderNetwork(el, id) {
        var o = this;
        var target = el.closest(".box-case").find(".ref_network");
        var case_id = el.closest(".box-case").find(".case_id").text();
        if (!target.hasClass("not_rendered")) {
            return false;
        }
        var has_sh = false;
        target.removeClass("not_rendered");
        var net = o.options.network[id];
        var rendered = [];
        var anchors = target.find("a");
        $.each(anchors, function (i, a) {
            a = $(a);
            var tid = a.data("id");
            $.each(net.inNetwork, function (t, n) {
                if (t == tid) {
                    a.append(n);
                    rendered.push(t);
                }
            });
        });
        $.each(net.inNetwork, function (t, n) {
            has_sh = true;
            if ($.inArray(t, rendered) === -1) {
                var html =
                    '<a data-id="' +
                    t +
                    '" class="col-xs-12 col-sm-6 btn-block btn-xs btn bg-olive btn-flat doOCR" data-url="ocr?case=' +
                    case_id +
                    "&sh=" +
                    t +
                    '">' +
                    n +
                    "</a>";
                target.find(".ref_network_not_referred").append(html);
            }
        });
        $.each(net.nearSHs, function (t, n) {
            has_sh = true;
            var html =
                '<a data-id="' +
                t +
                '" class="joinNetwork2 col-xs-12 col-sm-6 btn-block btn-xs btn btn-primary btn-flat">' +
                n +
                "</a>";
            target.find(".ref_network_not_networked").append(html);
        });
        if (!has_sh) {
            target.html(
                '<button class="btn-block btn-xs btn bg-orange btn-flat">No Specialty Hospitals in your area</button>'
            );
        }
    }
    hideNetwork(el) {
        el.removeClass("clicked_on");
        this.hideOcrBlockContent(el.closest(".box-case").find(".ocr_block_content"));
    }

    onWindowResize() {
        var o = this;
        var width = $(".case_canvas").width();
        var height = width * 0.6;

        $(".case_canvas").css({ height: height + "px" });
        $(".action-btns").each(function () {
            var wrapper = $(this);
            var buttons = wrapper.find(".btn-app");
            var btnSize = buttons.outerWidth();
            var btnsSize = btnSize * buttons.length;
            var btnsSizeExtra = 5 * (buttons.length - 1);
            var wrapWidth = btnsSize + btnsSizeExtra + 5;
            var btnsWrapParent = wrapper.find(".action-btns-btns-wrapp");
            var btnsWrap = wrapper.find(".action-btns-btns-wrap");
            btnsWrapParent.removeAttr("style");
            btnsWrap.removeAttr("style");
            wrapper.addClass("no_scrolling");
            if (wrapper.width() > wrapWidth) {
                btnsWrap.width(wrapWidth);
                return;
            }
            var widthOffset = wrapWidth - wrapper.width() + 30;

            var extra_margin = 0;
            if (Modernizr.touchevents && $(window).width() <= 1024) {
                extra_margin = 42;
            }

            btnsWrap.width(wrapWidth);
            if (widthOffset < 10) {
                return;
            }
            wrapper.removeClass("no_scrolling");
            btnsWrapParent.css({
                width: wrapWidth + widthOffset,
                "margin-left": "-" + (widthOffset - extra_margin) + "px",
            });
            btnsWrap
                .css({
                    left: widthOffset + "px",
                })
                .data("minleft", widthOffset)
                .data("maxleft", wrapWidth + widthOffset)
                .data("scrollsize", btnSize);
            o.initDragActionButtons();
        });
        $.each($(".loadImage"), function (i, m) {
            m = $(m);
            m.removeClass("loadImage");
            var img = new Image();
            var src = m.data("src");
            if (typeof src !== "undefined") {
                img.onload = function () {
                    m.attr("src", src);
                };
                img.src = src;
            }
        });
    }

    initDragActionButtons() {
        $(".action-btns-btns-wrap").each(function () {
            var actionBtns = $(this);
            actionBtns.draggable({
                axis: "x",
                snap: true,
                snapTolerance: actionBtns.find("btn-app").width() + 3,
                containment: "parent",
            });
        });
    }

    completeReferralProcess(caseId, data, json, test) {
        var o = this;
        var case_block = $(".caseblock_" + caseId);
        if (test) {
            var ref = o.options.refData;
            caseId = ref.caseId;
            data = ref.data;
            json = ref.json;
        }
        o.options.refData = {
            caseId: caseId,
            data: data,
            json: json,
        };
        $(".referral_" + caseId)
            .modal("hide")
            .remove();
        var ocrCount = 1;
        var ocr_block = case_block.find(".ocr_block");
        var sentSpan = ocr_block.find("span.bg-yellow");
        if (sentSpan.length > 0) {
            ocrCount += parseInt(ocr_block.find("span").html(), 10);
            sentSpan.html(ocrCount);
        }
        if (data.message.length > 0) {
            var ocrMessage = case_block.find(".ocr_message_done");
            var ocrMessage2 = case_block.find(".ocr_message");
        } else {
            var ocrMessage = case_block.find(".ocr_message");
            var ocrMessage2 = case_block.find(".ocr_message_done");
            ocrMessage.data("id", json.id);
        }
        ocrMessage.removeClass("hide").data("id", json.id).find(".shname").html(json.hospital);
        ocrMessage2.find(".shname").html(json.hospital);
        ocrMessage2.find(".shphone").html(json.hospitalPhone);
        ocrMessage.find(".shphone").html(json.hospitalPhone);
        var caseDelete = case_block.find(".caseDelete");
        var successMessage = caseDelete.data("stored-message");
        var storeURL = caseDelete.data("stored-url");
        caseDelete.replaceWith(
            '<a data-done-function="shred" href="#" data-url="' +
                storeURL +
                '" data-success-message="' +
                successMessage +
                '" class="btn btn-app btn-flat bg-primary postFunction getUrl"><i class="vetology-database"></i>Store</a>'
        );
        case_block
            .find('.doOCR[data-id="' + data.sh + '"]')
            .addClass("active-referral")
            .append('<span class="badge bg-yellow pull-right">&#x2713; sent</span>');
    }

    getPatientRecords(patientData) {
        var data = {
            ClinicPatientID: patientData.clinicPatientID,
            FirstName: patientData.patientName,
            LastName: patientData.patientLastName,
            nc: true,
        };
        $("body").Vetology(
            "doRequest",
            "POST",
            data,
            window.location.href,
            function (json) {
                var html = "";
                if (
                    typeof json.patientsPerfectMatches != "undefined" &&
                    (json.patientsPerfectMatches.length > 0 || json.patientsOtherMatches.length > 0)
                ) {
                    html = this.getPatientRecordsProcessResult(html, json, data);
                } else {
                    //We submit the case automatically, there was no match
                    $(".errors_area")
                        .addClass("alert alert-danger")
                        .html(
                            '<a href="#" data-name="' +
                                data.FirstName +
                                '" data-lastname="' +
                                data.LastName +
                                '" data-clinicid="' +
                                data.ClinicPatientID +
                                '" class="vetology_pd noCaseFound label label-info" data-patient="0">No patients were found, creating your case</a>'
                        );
                    setTimeout(function () {
                        $(".noCaseFound").click();
                    });
                }
            },
            "JSON"
        );
    }

    processPatientsPerfectMatches(html, json) {
        $.each(json.patientsPerfectMatches, function (i, match) {
            match.Sex = match.Sex == null ? "" : match.Sex.toLowerCase();
            match.Sex = match.Sex == "f" ? "female" : "male";
            html += "<li>";
            html +=
                '<a href="#" class="vetology_pd createPetRecord label label-success" data-id="' +
                match.PatientID +
                '">';
            html += match.FirstName == null ? "" : match.FirstName + " ";
            html += match.LastName == null ? "" : match.LastName + " ";
            html += match.ClinicPatientID == null ? "" : match.ClinicPatientID + " ";
            html += match.Breed == null ? "" : match.Breed + " ";
            html += match.Species == null ? "" : match.Species + " ";
            html += match.RespPersonFirst == null ? "" : match.RespPersonFirst + " ";
            html += match.RespPersonLast == null ? "" : match.RespPersonLast + " ";
            html += match.RespPersonPhone == null ? "" : match.RespPersonPhone + " ";
            html += "</a>";
            html += "</li>";
        });
    }

    processPatientsOtherMatches(html, json) {
        $.each(json.patientsOtherMatches, function (i, match) {
            match.Sex = match.Sex == null ? "" : match.Sex.toLowerCase();
            match.Sex = match.Sex == "f" ? "female" : "male";
            html += "<li>";
            html +=
                '<a href="#" class="vetology_pd createPetRecord label label-warning" data-id="' +
                match.PatientID +
                '">';
            html += match.FirstName == null ? "" : match.FirstName + " ";
            html += match.LastName == null ? "" : match.LastName + " ";
            html += match.ClinicPatientID == null ? "" : match.ClinicPatientID + " ";
            html += match.Breed == null ? "" : match.Breed + " ";
            html += match.Species == null ? "" : match.Species + " ";
            html += match.RespPersonFirst == null ? "" : match.RespPersonFirst + " ";
            html += match.RespPersonLast == null ? "" : match.RespPersonLast + " ";
            html += match.RespPersonPhone == null ? "" : match.RespPersonPhone + " ";
            html += "</li>";
        });
    }

    getPatientRecordsProcessResult(html, json, data) {
        html += "<p>Please select which patient you would like to submit the case for</p><ul>";
        if (json.patientsPerfectMatches.length > 0) {
            this.processPatientsPerfectMatches(html, json);
        }
        if (json.patientsOtherMatches.length > 0) {
            this.processPatientsOtherMatches(html, json);
        }
        html +=
            '<li><a href="#" data-name="' +
            data.FirstName +
            '" data-lastname="' +
            data.LastName +
            '" data-clinicid="' +
            data.clinicPatientID +
            '" class="vetology_pd noCaseFound label label-info" data-patient="0">The patient is not on the list</a></li></ul>';
        $(".complete_area").html(html);
        return html;
    }

    /**
     * @description: checks if the case has been submitted
     *
     * @private
     */
    checkIfCaseSubmitted() {
        let o = this;
        var submitted = o.getUrlParam("submit");
        var case_id = o.getUrlParam("CaseID");
        let question = o.getUrlParam("question");
        if (submitted == "true" && case_id) {
            let $submitLink = $(
                '<a id="case-submit-now" data-video="submit-case" class="btn btn-app btn-flat bg-primary getUrl isSubmitButton video_help_toggler" data-url="ca/s?id=' +
                    case_id +
                    '" href="#"><i class="vetology-submit"></i>Submit</a>'
            );
            $("body").append($submitLink);
            $("#case-submit-now").click();
        }
    }

    getUrlParam(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        var value = results === null ? false : decodeURIComponent(results[1].replace(/\+/g, " "));
        return value;
    }

    /**
     * @description: for a special case submission (from ask Vetologist link), will set the needed defaults on the page
     *
     * @param caseID
     * @private
     */
    setAskVetologistDefaults(caseID) {
        let o = this;
        let $selector = $(".c_d_r_map_clinic");
        o.setAskVetologistDefaultControl($selector);
        o.renderMapClinic($selector);
        o.setAskVetologistDefaultControl($(".c_d_r_map_doctors"));
        $selector = $(".c_d_r_map_consultant_group");
        o.setAskVetologistDefaultControl($selector);
        o.renderMapConsultantGroup($selector);
        o.setAskVetologistDefaultControl($(".c_d_r_map_radiologist"));

        // if question isn't in pattern history, add it now
        let $patHistory = $("textarea[name='history']");
        let patHistoryText = $patHistory.val();

        // set patient history and claimed images read-only
        $("textarea[name=history]").prop("readonly", true);
        $("input[name=NumImagesEntry]").prop("readonly", true);
    }

    /**
     * @description sets the default value for the passed element
     * @param $selector
     * @private
     */
    setAskVetologistDefaultControl($selector) {
        let $options = $("option:enabled", $selector);
        if ($options.length === 1) {
            $selector.val($options.val());
        }
    }

    switchSubmissionClientType(event) {
        const boxContainer = event.target.closest(".box-body");
        const clientType = event.target.querySelector("input[type=radio]").value;

        const firstNameFormGroup = boxContainer.querySelector(".form-group.first-name");
        const lastNameFormGroup = boxContainer.querySelector(".form-group.last-name");
        const respPersonEmailFormGroup = boxContainer.querySelector(".form-group.resp-person-email");
        const respPersonPhoneFormGroup = boxContainer.querySelector(".form-group.resp-person-phone");
        const respOrgName = boxContainer.querySelector(".form-group.resp-org-name");
        const respOrgEmail = boxContainer.querySelector(".form-group.resp-org-email");
        const respOrgPhone = boxContainer.querySelector(".form-group.resp-org-phone");
        let name = "";
        let l;
        if (clientType == 1) {
            // owner
            firstNameFormGroup.classList.remove("hidden");
            lastNameFormGroup.classList.remove("hidden");
            respPersonEmailFormGroup.classList.remove("hidden");
            respPersonPhoneFormGroup.classList.remove("hidden");

            respOrgName.classList.add("hidden");
            respOrgEmail.classList.add("hidden");
            respOrgPhone.classList.add("hidden");
        } else {
            // organization
            firstNameFormGroup.classList.add("hidden");
            lastNameFormGroup.classList.add("hidden");
            respPersonEmailFormGroup.classList.add("hidden");
            respPersonPhoneFormGroup.classList.add("hidden");

            respOrgName.classList.remove("hidden");
            respOrgEmail.classList.remove("hidden");
            respOrgPhone.classList.remove("hidden");
        }
    }

    cancelCaseSubmission(event) {
        event.preventDefault();
        event.stopPropagation();
        const caseCard = event.target.closest("div[data-case]");
        const caseID = caseCard.dataset.case;
        const cancelSubmitDlg = document.querySelector("div.modal.cancel-submission");
        cancelSubmitDlg.dataset.case_id = caseID;
        $(cancelSubmitDlg).modal();
    }

    submitReadCancellation(event) {
        event.preventDefault();
        event.stopPropagation();

        const formData = new FormData();
        const modalElem = event.target.closest(".modal.cancel-submission");
        const reasonElem = modalElem.querySelector("textarea[name=cancellation-reason]");
        if (reasonElem.value.trim().length === 0) {
            $("body").Vetology(
                "vetologyShowDialog",
                "Attention:",
                "Please supply a reason for cancelling this read",
                "error"
            );
            return;
        }

        formData.append("id", modalElem.dataset.case_id);
        formData.append("store", 4);
        formData.append("reason", reasonElem.value);
        fetch("/ca/s", {
            method: "post",
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    $("body").Vetology(
                        "vetologyShowDialog",
                        "Error:",
                        "Could not cancel your read at this time, please try back later.",
                        "error"
                    );
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                if (data.success) {
                    $(modalElem).modal("hide");
                    toastr.success("Your read was successfully cancelled.", "Success");
                    setTimeout(() => {
                        $(".isFilter").trigger("change");
                    }, 1000);
                } else {
                    $("body").Vetology("vetologyShowDialog", "Error:", data.errorMsg, "error");
                }
            });
    }

    checkForSubclinic() {}

    updateSubClinics() {
        const subClinicsSelect = document.querySelector("select[data-filter=SubClinicID]");

        if (window.vet_data) {
            let subClinics = JSON.parse(window.vet_data);
            if (typeof subClinics == "object" && Object.keys(subClinics).length > 0) {
                const clinicSelector = this.querySelector("select[data-filter=ClinicID]");
                const parentClinicID = clinicSelector.value;
                const currentValue = subClinicsSelect.value;
                const optionCount = subClinicsSelect.querySelectorAll("option").length;
                if (
                    currentValue === "" ||
                    optionCount == 1 ||
                    (optionCount > 1 &&
                        parentClinicID !== subClinicsSelect.querySelector("option:last-of-type").dataset.parentClinicId)
                ) {
                    this.clearSubClinics();
                    subClinics = Object.entries(subClinics);
                    subClinics.forEach((subClinic) => {
                        const option = document.createElement("option");
                        option.value = subClinic[0];
                        option.textContent = subClinic[1];
                        option.dataset.parentClinicId = parentClinicID;
                        subClinicsSelect.appendChild(option);
                    });
                    const selectContainer = subClinicsSelect.closest(".inline-control");
                    selectContainer.style.display = "flex";
                    selectContainer.style.alignItems = "center";
                }
                return;
            }
        }

        this.clearSubClinics();
    }

    clearSubClinics() {
        const subClinicsSelect = document.querySelector("select[data-filter=SubClinicID]");
        const options = subClinicsSelect.querySelectorAll("option");
        options.forEach((option) => {
            if (option.value != "") {
                option.remove();
            }
        });
        const selectContainer = subClinicsSelect.closest(".inline-control");
        selectContainer.style.display = "none";
        subClinicsSelect.value = "";
    }

    createWorklistMenuBadge() {
        // creates a badge in the left menu for the Worklist page, to show the number of cases in the worklist that have unread ai reports
        let badge = document.querySelector("#unread-ai-report-case-count-badge");

        if (!badge) {
            badge = document.createElement("div");
            badge.id = "unread-ai-report-case-count-badge";
            const badgeLink = document.createElement("a");
            badgeLink.href = "javascript:void(0)";
            const popOver = document.createElement('pop-over');
            popOver.textContent = "Click to filter worklist to cases with unread AI reports";
            badge.appendChild(popOver);
            badge.appendChild(badgeLink);
            const menuSidebar = document.querySelector("menu-sidebar");
            const clinicLink = menuSidebar.querySelector("a[href='/worklist/clinic']");
            badge.style.display = "none";
            clinicLink.appendChild(badge);
            badge.addEventListener("click", this.showWorklistWithUnreadAiReports.bind(this));
        } 

        this.updateMenuBadgeAndCases();
    }

    showWorklistWithUnreadAiReports(event) {
        event.preventDefault();

        const reportStatusFilter = document.querySelector("#id_status");
        if (reportStatusFilter) {
            reportStatusFilter.value = "2";
            $(reportStatusFilter).trigger("change");
        }
    }   
    
    updateMenuBadgeAndCases() {
        // get total and case specific unread ai report counts for the current cases in the worklist, and update the menu badge and case cards accordingly
        const worklistCases = this.getWorklistDisplayedCases();

        const formData = this.getWorklistFormData();
        formData.append("case_ids", worklistCases.join(","));

        fetch("/worklist/get-unread-ai-report-counts", {
            method: "POST",
            body: formData,
            expect: "json"
        }).then(response => {
            if (response.status === 200) {
                return response.json().then(data => {
                    if (data.success) {
                        const badge = document.querySelector("#unread-ai-report-case-count-badge");
                        if (badge) {
                            const badgeLink = badge.querySelector("a");
                            if (badgeLink) {
                                badgeLink.textContent = data.total_unread_count;
                            }
                            if (data.total_unread_count > 0) {
                                badge.style.display = "flex";
                            } else {
                                badge.style.display = "none";
                            }
                        }
                        const caseList = document.querySelectorAll(".case-card-container");
                        caseList.forEach((caseCard) => {
                            const caseID = caseCard.dataset.case;
                            if (caseID && data.case_counts[caseID] !== undefined) {
                                if (caseCard.dataset.unread_ai_report_case_count != data.case_counts[caseID]) {
                                    caseCard.dataset.unread_ai_report_case_count = data.case_counts[caseID];
                                }
                            }
                        });
                    }
                });
            }
        });

    }

    getWorklistDisplayedCases() {
        const caseList = document.querySelectorAll(".case-card-container");
        const worklistCases = [];
        caseList.forEach((caseCard) => {
            const caseID = caseCard.dataset.case;
            if (caseID) {
                worklistCases.push(caseID);
            }
        });
        return worklistCases;
    }

    getWorklistFormData() {
        let startDate = '', endDate = '';
        const dateRangePicker = document.querySelector("date-range-picker");
        if (dateRangePicker) {
            startDate = dateRangePicker.startDate;
            endDate = dateRangePicker.endDate;
        } else {
            startDate = new Date();
            startDate.setDate(startDate.getDate() - 60);
            endDate = new Date();
        }
        const firstNameFilter = document.querySelector("#id_first_name");
        const lastNameFilter = document.querySelector("#id_last_name");
        const clinicFilter = document.querySelector("#id_clinic");
        const teleradRptFilter = document.querySelector("#id_rad_rpt_priority");
        const subClinicFilter = document.querySelector("#id_sub_clinic");
        const speciesFilter = document.querySelector("#id_species");
        const modalityFilter = document.querySelector("#id_modality");
        const caseFilter = document.querySelector("#id_case_id");

        const formData = new FormData();
        formData.append("start_date", startDate.toISOString().slice(0, 10));
        formData.append("end_date", endDate.toISOString().slice(0, 10));
        formData.append("first_name", firstNameFilter ? firstNameFilter.value : "");
        formData.append("last_name", lastNameFilter ? lastNameFilter.value : "");
        formData.append("clinic", clinicFilter ? clinicFilter.value : "");
        formData.append("sub_clinic", subClinicFilter ? subClinicFilter.value : "");
        formData.append("species", speciesFilter ? speciesFilter.value : "");
        formData.append("modality", modalityFilter ? modalityFilter.value : "");
        formData.append("case_id", caseFilter ? caseFilter.value : "");
        formData.append("telerad_rpt_priority", teleradRptFilter ? teleradRptFilter.value : "");
        return formData;
    }
}

customElements.define("work-list", WorkList);
